/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_DeletedInputs */

const en_resumes_deleted = /** @type {(inputs: Resumes_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume deleted`)
};

const de_resumes_deleted = /** @type {(inputs: Resumes_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf gelöscht`)
};

const fr_resumes_deleted = /** @type {(inputs: Resumes_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV supprimé`)
};

const es_resumes_deleted = /** @type {(inputs: Resumes_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículum eliminado`)
};

const it_resumes_deleted = /** @type {(inputs: Resumes_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum eliminato`)
};

const nl_resumes_deleted = /** @type {(inputs: Resumes_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV verwijderd`)
};

const pl_resumes_deleted = /** @type {(inputs: Resumes_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV usunięte`)
};

const fi_resumes_deleted = /** @type {(inputs: Resumes_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelo poistettu`)
};

const da_resumes_deleted = /** @type {(inputs: Resumes_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV slettet`)
};

const sv_resumes_deleted = /** @type {(inputs: Resumes_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV raderat`)
};

/**
* | output |
* | --- |
* | "Resume deleted" |
*
* @param {Resumes_DeletedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_deleted = /** @type {((inputs?: Resumes_DeletedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_DeletedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_deleted(inputs)
	if (locale === "fr") return fr_resumes_deleted(inputs)
	if (locale === "es") return es_resumes_deleted(inputs)
	if (locale === "it") return it_resumes_deleted(inputs)
	if (locale === "nl") return nl_resumes_deleted(inputs)
	if (locale === "pl") return pl_resumes_deleted(inputs)
	if (locale === "fi") return fi_resumes_deleted(inputs)
	if (locale === "da") return da_resumes_deleted(inputs)
	if (locale === "sv") return sv_resumes_deleted(inputs)
	return en_resumes_deleted(inputs)
});